import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  OnDestroy,
  inject,
} from "@angular/core";
import { NgIf } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { Segment } from "src/app/helpers/segment";
import { SelectionService } from "src/app/services/selection.service";

const DUMMY_VIDEO =
  "data:video/mp4;base64, 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";

/**
 *
 * Gestisce gli eventi del player video e sincronizza la riproduzione con i contenuti del corso.
 */
@Component({
  selector: "app-player-events",
  templateUrl: "./player-events.component.html",
  styleUrls: ["./player-events.component.scss"],
  standalone: true,
  imports: [NgIf, MatIconButton, MatTooltip, MatIcon, TranslatePipe],
})
export class PlayerEventsComponent implements OnInit, OnDestroy {
  //Impostazioni
  @Input()
  get media(): string {
    return this._media;
  }
  set media(value: string) {
    if (value != this._media) {
      this._media = value;

      if (this.player) {
        this.player.pause();
        this.player.load();

        this.player.muted = this.mute;
        this.player.controls = this.enableControls;
        this.player.currentTime = this.startTime;

        this.player.play();
      }
    }
  }

  @Input()
  isAuthor: boolean = false; // 31/03/2026 do not track content if current user is content author

  @Input()
  controls: string;

  @Input()
  enableControls: boolean = false;

  @Input()
  get mute(): boolean {
    return this._mute;
  }
  set mute(value: boolean) {
    this._mute = value;

    if (this.player) {
      this.player.muted = this._mute;
    }
  }

  @Input()
  get startTime(): number {
    return this._startTime;
  }
  set startTime(value: number) {
    this._startTime = value;
    this.startTimeChange.emit(this.startTime);

    if (this.disableSeekCheck) {
      this.player ? (this.player.currentTime = value) : this._startTime;
    }
  }

  @Input()
  width: string = "100%";

  @Input()
  height: string = "";

  @Input()
  get pause(): boolean {
    return this._pause;
  }
  set pause(value: boolean) {
    this._pause = value;

    if (this.player) {
      value ? this.player.pause() : this.player.play();
    }
  }

  @Input()
  disableSeekCheck: boolean = false;

  @Input()
  shadow: boolean = false;

  @Input()
  objectFit: string = "contain";

  @Input()
  showMute: boolean = false;

  @Input()
  showPlay: boolean = false;

  @Input()
  caption: { label: string; url: string } | null = null;

  //Eventi
  @Output()
  startTimeChange: EventEmitter<number> = new EventEmitter<number>();

  @Output() //[0] tempo DA cui si è fatto il seek, [1] tempo A cui si è fatto il seek
  seek: EventEmitter<number[]> = new EventEmitter<number[]>();

  @Output()
  firstPlayed: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  played: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  paused: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  ended: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  close: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  time: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  duration: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  segmentBatch: EventEmitter<Array<Segment>> = new EventEmitter<
    Array<Segment>
  >();

  //Informazioni
  public get currentTime(): number {
    return this.player.currentTime;
  }

  @ViewChild("videoplayer", { static: true }) videoElement;

  private player: HTMLVideoElement;
  private _media: string;
  private _startTime: number = 0;
  private _pause: boolean = false;
  private _mute: boolean = false;

  private isSaveMarker: boolean = true;
  private isFirstPlay: boolean = true;
  private segment: Segment = new Segment(this.startTime, this.startTime);

  private intervalSegments: Array<Segment> = [];

  private selectionService = inject(SelectionService);

  private tail: number[] = [];

  private isSeeking: boolean = false;

  /**
   * non tracciare se è attiva la modalità di selezione o se l’utente corrente è l’autore.
   * @returns `false` se l'utente corrente è l'autore oppure se è attiva la modalità di selezione.
   */
  private neitherAuthorNorSelectionMode(): boolean {
    return !(this.isAuthor || this.selectionService.showSelection);
  }

  /**
   *
   * Rilascia i gestori degli eventi del lettore e le risorse associate.
   */
  public ngOnDestroy(): void {
    if (this.neitherAuthorNorSelectionMode()) {
      if (
        this.segment?.start < this.segment?.end &&
        !Segment.compare(
          this.segment,
          this.intervalSegments.at(-1),
          Segment.startEndEquals,
        )
      ) {
        // 15/04/2026 valid segment and try to avoid duplicates
        this.intervalSegments.push(
          new Segment(
            this.segment.start,
            this.player.currentTime,
            this.segment.startTime,
            new Date(),
          ),
        );
      }
      this.intervalSegments = Segment.fixSegments(this.intervalSegments);

      this.segmentBatch.emit(this.intervalSegments);
    }
    this.player.pause();
    this.player.src = DUMMY_VIDEO;
    this.player.remove();
  }

  private readonly EPSILON = 1e-9;

  /**
   * Trova, procedendo da destra, il primo indice in cui la distanza tra un elemento e il precedente
   * l’elemento è maggiore di gapThresholdSeconds.
   *
   * Restituisce:
   *  - indice (>=1) dell'elemento a destra per cui l'intervallo è maggiore della soglia;
   *  - `0` se non è stato trovato alcun intervallo superiore alla soglia (tutti contigui);
   *  - `-1` se la coda è vuota.
   * @param tail Array crescente di timestamp numerici (secondi).
   * @param gapThresholdSeconds Soglia in secondi (valore predefinito: 1).
   * @returns Primo indice in cui è presente un intervallo, -1 se non ne viene trovato nessuno.
   */
  public findFirstIndexWithGapFromRight(
    tail: number[],
    gapThresholdSeconds = 1,
  ): number {
    if (!tail || tail.length === 0) {
      return -1;
    }
    if (tail.length === 1) {
      return 0;
    } // single element -> no gap

    let index: number = tail.length - 1;

    // iterate from right to left using while
    while (index > 0) {
      const current: number = tail[index];
      const previous: number = tail[index - 1];
      const delta: number = current - previous;

      // use EPSILON to tolerate tiny floating point rounding
      if (delta > gapThresholdSeconds - this.EPSILON) {
        return index - 1;
      }

      index--;
    }

    // no gap found
    return -1;
  }

  // ---------------------------
  // Bound handler properties
  // ---------------------------

  /**
   * Gestore associato all'evento seeking (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onseeking.
   */
  private boundOnSeeking: () => void = () => {
    if (!this.isSeeking) {
      this.isSeeking = true;

      if (this.segment.start !== this.segment.end) {
        // 15/04/2026 when user drags the audio player pointer segment start and end are usually equal
        // compute the boundary index where a gap > 1s occurs scanning from right
        const boundaryIndex: number = this.findFirstIndexWithGapFromRight(
          this.tail,
          1,
        );

        // handle special cases
        if (boundaryIndex === -1) {
          // no tail data -> nothing to add (or handle as you need)
          this.isSeeking = false;
          return;
        }

        // choose how to derive new Segment start & end from tail:
        // - startNumber: value at boundaryIndex
        // - stopNumber: last value in tail
        const stopNumber: number = Math.floor(this.tail[boundaryIndex]);

        // push a new interval segment (adjust fields as required)
        this.intervalSegments.push(
          new Segment(
            this.segment.start,
            stopNumber,
            this.segment.startTime,
            this.segment.stopTime,
          ),
        );
        this.segment = new Segment(
          stopNumber,
          stopNumber,
          new Date(),
          new Date(),
        );
      }
    }
  };

  /**
   * Gestore associato all'evento seeked (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onseeked.
   */
  private boundOnSeeked: () => void = () => {
    this.isSeeking = false;
    this.tail = [];
    this.segment = new Segment(
      this.player.currentTime,
      this.player.currentTime,
      new Date(),
      new Date(),
    );
  };

  /**
   * Gestore associato all'evento timeupdate (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.ontimeupdate.
   */
  private boundOnTimeUpdate: () => void = () => {
    if (this.isSaveMarker) {
      this.tail.push(this.player.currentTime);
      if (this.tail.length > 10) {
        this.tail.shift();
      }
      this.segment.end = this.player.currentTime;
      this.segment.stopTime = new Date();
    }
  };

  /**
   * Gestore associato all'evento play (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onplay.
   */
  private boundOnPlay: () => void = () => {
    this.played.emit(this.player.currentTime);
    this.segment = new Segment(
      this.player.currentTime,
      this.player.currentTime,
      new Date(),
      new Date(),
    );
    if (this.isFirstPlay) {
      this.isFirstPlay = false;
      this.firstPlayed.emit(0);
    }
  };

  /**
   * Gestore associato all'evento pause (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onpause.
   */
  private boundOnPause: () => void = () => {
    this.intervalSegments.push(
      new Segment(
        this.segment.start,
        this.player.currentTime,
        this.segment.startTime,
        new Date(),
      ),
    );
  };

  /**
   * Gestore associato all'evento ended (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onended.
   */
  private boundOnEnded: () => void = () => {
    // console.log('audio ended');
    if (
      !Segment.compare(
        this.intervalSegments?.at(-1),
        this.segment,
        Segment.structuralEqualityCloseEnd,
      )
    ) {
      // 27/03/2026 browser may emit paused and ended when the audio ends (and may have slightly different timestamp)
      // 27/03/2026 -> avoid duplicates and save only one
      this.intervalSegments.push(
        new Segment(
          this.segment.start,
          this.player.currentTime,
          this.segment.startTime,
          this.segment.stopTime,
        ),
      );
    }
  };

  /**
   * Gestore associato all'evento loadeddata (registrato con addEventListener).
   * Mantiene la logica originale, precedentemente definita in this.player.onloadeddata.
   */
  private boundOnLoadedData: () => void = () => {
    this.duration.emit(this.player.duration);
  };

  /**
   *
   * Inizializza l'elemento video nativo e la gestione degli eventi del player.
   */
  public ngOnInit(): void {
    this.player = this.videoElement.nativeElement as HTMLVideoElement;

    this.player.muted = this.mute;
    this.player.controls = this.enableControls;
    this.player.load();

    const startTime: number = this.startTime;
    this.player.currentTime = startTime; // 25/03/2026 set the timer to the current time
    // 27/03/2026 note that the backend keeps track of the time in integers (not float) -> loss of precision
    this.segment = new Segment(startTime, startTime, new Date(), new Date()); // 27/03/2026 initial default value

    if (!this.pause) {
      this.player.play();
    }

    // 14/04/2026 do not track seeking for now since order
    // 14/04/2026 seeking pause etc events is browser dependant
    // 14/04/2026 so use an heuristic in the Segment.fixSegments
    // 14/04/2026 (if start and stop time are too much different wrt start and stop position)

    // 27/03/2026 seeked: event fired when user stops the pointer dragging in the player
    if (this.neitherAuthorNorSelectionMode()) {
      // register listeners with addEventListener (store references above)
      this.player.addEventListener("seeking", this.boundOnSeeking);
      this.player.addEventListener("seeked", this.boundOnSeeked);
      this.player.addEventListener("timeupdate", this.boundOnTimeUpdate);
      this.player.addEventListener("play", this.boundOnPlay);
      this.player.addEventListener("pause", this.boundOnPause);
      this.player.addEventListener("ended", this.boundOnEnded);
    }

    // always register loadeddata to emit duration
    this.player.addEventListener("loadeddata", this.boundOnLoadedData);
  }
}
